import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import {observer} from "mobx-react"
import BienStore from "../BienStore"
import axios from "axios"

@observer
class Pieces extends React.Component {
  constructor(props) {
    super(props);
    this.handleMore = this.handleMore.bind(this)
    this.showNextBTN = this.showNextBTN.bind(this)
    this.showPrecedentBTN = this.showPrecedentBTN.bind(this)
    this.handleLess = this.handleLess.bind(this)
    this.getCurrentNmbr = this.getCurrentNmbr.bind(this)
    this.indexparams = this.indexparams.bind(this)
    this.state = {
      // typesdebiens: [],
      loaded: false,
      index: 0
    };
  }
  indexparams(){
    return(parseInt(this.props.match.params.id))
  }
  getCurrentNmbr(){
    let index = this.indexparams()
    let piece = BienStore.typesdepieces[index]
    if(BienStore.pieces[piece.id]===undefined){
      return (<span>0</span>)
    }else{
      return (<span>{BienStore.pieces[piece.id].quantite}</span>)
    }
  }
  handleLess(e){
    e.preventDefault()
    let index = this.indexparams()
    let piece = BienStore.typesdepieces[index]
    if(BienStore.pieces[piece.id]===undefined){
      // BienStore.pieces[piece.id]={titre: piece.titre,id: piece.id,index: index, quantite: 1}
    }else{
      if(BienStore.pieces[piece.id]["quantite"]>0){
        BienStore.pieces[piece.id]["quantite"] -= 1
      }
    }
  }
  handleMore(e){
    e.preventDefault()
    let index = this.indexparams()
    let piece = BienStore.typesdepieces[index]
    if(BienStore.pieces[piece.id]===undefined){
      BienStore.pieces[piece.id]={titre: piece.titre,id: piece.id,index: index, quantite: 1}
    }else{
      BienStore.pieces[piece.id]["quantite"] += 1
    }
  }
  showNextBTN(){
    let index = this.indexparams() + 1
    if(BienStore.typesdepieces[index]==undefined){
    return <p><Link className="btn btn-large wave" to="/done">Suivant</Link></p>

    }else{
      return <p><Link className="btn btn-large wave" to={"/piece/"+index}>Prochaine piece</Link></p>
    }
  }
  showPrecedentBTN(){
    let index = this.indexparams()-1
    if(index<0){
    return <p><Link className="btn btn-large wave disabled" to="">Précédent</Link></p>

    }else{
      return <p><Link className="btn btn-large wave grey" to={"/piece/"+index}>Précedent</Link></p>
    }
  }
  render () {
      if(BienStore.typesdepieces.length >0){
      let index = this.indexparams()
      let piece = BienStore.typesdepieces[index]
        return(
            <React.Fragment>
            <div className="row noselect">
              <div className={"col m6 hide-on-small-only side-image side-image-"+piece.titre}>
              </div>
              <div className="col m6 s12">
                <h1 className="center">{piece.titre}</h1>
                <div className="row">

                <div className='center'>
                <p className="center">
                  {piece.text}
                </p>
                <h1>
                <span className="btn wave red btn-large" style={styles.btn} onClick={this.handleLess}>-</span> {this.getCurrentNmbr()}

                <span className="btn wave green btn-large" style={styles.btn} onClick={this.handleMore} href="">+</span>
                </h1>
                </div>
                </div>
              <div className="row">
                <div className="col s4 offset-s1">
                  {this.showPrecedentBTN()}
                </div>
                <div className="col s4 offset-s2">
                {this.showNextBTN()}
                </div>
              </div>

              </div>
            </div>
            </React.Fragment>
          )
      }else{
        return(
            <div>
              <p>chargemnt en cours</p>
            </div>
          )
      }
    }
}
export default Pieces

const styles ={
  btn: {
    fontSize: "40px",
    margin: "20px"
  }
}
